enum BiteLogHeartlandEvent {
  None = 0,
  TerminalDisconnected = 1,
  UpdateIdleTextError = 2,
  RefundError = 4,
  AuthTransaction = 5,
  AuthTransactionError = 6,
  SaleTransaction = 7,
  SaleTransactionError = 8,
  BalanceInquiry = 9,
  BalanceInquiryError = 10,
  TerminalConnected = 11,
  TerminalInitFailed = 12,
  SetupDevice = 13,
  DeviceResetFailed = 14,
  NativeTransaction = 15,
  NativeTransactionError = 16,
  TransactionLookup = 17,
  TransactionLookupError = 18,
}

export { BiteLogHeartlandEvent };
